import MsOfficeIcon from "../../../assets/icons/ms-office-360.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import Linked from './Linked';
import { OUTLOOK_CALENDAR_ID } from '../../../data/integration-app';

const Office365Calendar = ({connectedVenues}) => {
    return (
        <Col md="6" xxl="3" xl="4">
            <Link to="/admin/calendar-integration" className="int-col">
            {connectedVenues.some(data => parseInt(data.app_id) === OUTLOOK_CALENDAR_ID) && <Linked />}
            <div className="img">
                <img src={MsOfficeIcon} alt="Google Calendar" />
            </div>
            <div className="text">
                <h3>Office 365 Calendar</h3>
                <p>
                Manage your schedule with Outlook Calendar — organize meetings, events, and reminders seamlessly.
                </p>
            </div>
            </Link>
        </Col>
    );
}

export default Office365Calendar;